import moment from 'moment';
import sanitizeHtml from 'sanitize-html';

const AVATAR_COLORS = [
    '#1A8EC0', '#0E7E68', '#7B5EA7', '#C0553A',
    '#1A7EC0', '#9C8B00', '#3A6EA7', '#A75E82',
];

export function avatarColor(name) {
    const str = name || '?';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function chatInitials(name) {
    const words = (name || '?').trim().split(/\s+/);
    if (words.length === 1) {
        return words[0][0].toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export function renderInitialsAvatarHtml(name, size = 46) {
    const bg = avatarColor(name);
    const initials = chatInitials(name);
    const fontSize = size >= 46 ? 17 : 15;
    return `<span class="chat-initials-avatar" style="width:${size}px;height:${size}px;background-color:${bg};font-size:${fontSize}px">${initials}</span>`;
}

export function dateSeparatorLabel(date) {
    const d = moment(date);
    if (d.isSame(moment(), 'day')) {
        return 'Today';
    }
    if (d.isSame(moment().subtract(1, 'day'), 'day')) {
        return 'Yesterday';
    }
    if (d.isSame(moment(), 'year')) {
        return d.format('ddd, MMM D');
    }
    return d.format('MMM D, YYYY');
}

export function shouldShowDateSeparator(prevDate, currentDate) {
    if (!prevDate) {
        return true;
    }
    return !moment(prevDate).isSame(moment(currentDate), 'day');
}

export function isGroupedWithPrevious(prev, current) {
    if (!prev || !current) {
        return false;
    }
    const sameSender =
        prev.user_id === current.user_id ||
        (prev.sender_user_id > 0 &&
            current.sender_user_id > 0 &&
            prev.sender_user_id === current.sender_user_id);
    if (!sameSender) {
        return false;
    }
    if (shouldShowDateSeparator(prev.date, current.date)) {
        return false;
    }
    return Math.abs(moment(current.date).diff(moment(prev.date), 'minutes')) < 5;
}

export function formatBubbleTime(dateString) {
    const createdAt = moment.utc(dateString).local();
    if (createdAt.isSame(moment(), 'day')) {
        return createdAt.format('h:mm A');
    }
    return createdAt.format('ddd h:mm A');
}

export function stripHtmlForPreview(html) {
    if (!html) {
        return '';
    }
    return sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} }).trim();
}

export function renderReplyQuoteHtml(reply, mineMsg) {
    if (!reply) {
        return '';
    }
    const sender = sanitizeHtml(reply.sender_name || 'Reply', { allowedTags: [], allowedAttributes: {} });
    const text = sanitizeHtml(reply.text || stripHtmlForPreview(reply.message) || '', {
        allowedTags: [],
        allowedAttributes: {},
    });
    return `<div class="reply-quote ${mineMsg ? 'reply-quote-mine' : 'reply-quote-other'}">
        <span class="reply-quote-name">${sender}</span>
        <span class="reply-quote-text">${text}</span>
    </div>`;
}

export function renderDateSeparatorHtml(date) {
    return `<div class="chat-date-separator"><span class="chat-date-separator-pill">${dateSeparatorLabel(date)}</span></div>`;
}

export function participantsSubtitle(selectedChat, onlineCount) {
    if (!selectedChat) {
        return '';
    }
    if (selectedChat.is_public || selectedChat.name === 'Public Chat') {
        return `${onlineCount} online`;
    }
    const count = selectedChat.members?.length || selectedChat.participants || 0;
    return count > 0 ? `${count} participants` : `${onlineCount} online`;
}

export function isMessageSeenByOthers(readBy, myUniqueId, myUserId = 0) {
    if (!Array.isArray(readBy)) {
        return false;
    }
    return readBy.some((id) => {
        if (id === myUniqueId) {
            return false;
        }
        if (myUserId > 0 && id === myUserId) {
            return false;
        }
        return true;
    });
}

export function getLastMineMessageIndex(messages, myUniqueId, myUserId = 0) {
    let lastIndex = -1;
    messages.forEach((m, i) => {
        if (
            m.user_id === myUniqueId ||
            (myUserId > 0 && m.sender_user_id === myUserId)
        ) {
            lastIndex = i;
        }
    });
    return lastIndex;
}
